import {PageProps} from '@/types';
import Page from "@/Pages/Page";
import titleImage from '@images/media/condoleance-register.png'
import imagePhoneFront from '@images/media/phone-front.png'
import imagePhoneContact from '@images/media/phone-contact.png'
import imagePhoneResult from '@images/media/phone-result.png'
import imagePhoneDesign from '@images/media/phone-design.png'
import imageFuncHerdenkingspagina from '@images/media/widget_usp1.png'
import imageFuncAanvulling from '@images/media/widget_usp2.png'
import imageFuncCondoleance from '@images/media/widget_usp3.png'
import {TabPanel, Tabs, Tab} from "@/Molecules/Tabs/Tabs";
import CTA_B2B from "@/Organisms/CallToAction/CTA_B2B";
import React, {useState} from "react";
import styles from './OnlineCondoleanceregister.module.scss'
import Quote from "@/Molecules/Quote/Quote";
import imageOnlineRouwbericht1 from "@images/media/online-rouwbericht/online-rouwbericht-1.png";
import SectionHeader from "@/Organisms/SectionHeader/SectionHeader";
import {relativeRoute} from "@/helpers/relativeRoute";

export default function OnlineCondoleanceregister() {

  const [currentTab, setCurrentTab] = useState(0)
  return (
    <Page title={'Online condoleanceregister'} harvestId={10404}>

      <SectionHeader
        beige
        image={titleImage}
        title={'Online condoleanceregister'}
        content={<>
          <p>Maak jouw dienstenaanbod completer, jouw werkwijze efficiënter en investeer in online vindbaarheid door
            eenvoudig
            het <strong>gratis</strong> online condoleanceregister van Mensenlinq aan jouw website toe te voegen.</p>
          <div className={'my-5'}>
            <a href={'https://forms.office.com/e/sE5fZgtB91'} className={'btn'}>Afspraak inplannen</a>
          </div>
        </>}
      />


      <section>
        <div className="container dual">
          <div>
            <h2>Het online condoleanceregister is voor jou een:</h2>
            <ul className={'small'}>
              <li>Gratis uitbreiding van jouw online dienstenaanbod</li>
              <li>Multifunctioneel inzetbare en gebruiksvriendelijke tool die door Mensenlinq wordt geïnstalleerd,
                beheerd en onderhouden
              </li>
              <li>Directe investering in online vindbaarheid</li>
              <li>Effectieve manier om structureel bezoekers naar jouw website te trekken</li>

            </ul>
          </div>
          <div>
            <h2>Het online condoleanceregister is voor de
              nabestaanden een *:</h2>
            <ul className={'small'}>
              <li>Centrale plek voor het ontvangen van condoleances en het plaatsen van praktische informatie over de
                uitvaart
              </li>
              <li>Online aanvulling op het handgeschreven condoleanceregister en de rouwkaart</li>
              <li>Betekenisvol middel dat op ieder gewenst moment eenvoudig uit te breiden is tot <a
                href={relativeRoute('uitgebreide-rouwpagina')}>uitgebreide
                rouwpagina</a>, waarbij praktische informatie over de uitvaart kan worden toegevoegd.
              </li>
            </ul>
            <span className={'text-sm'}>* Bij <a
              href={relativeRoute('online-rouwpagina')}>doorplaatsing rouwadvertentie</a> naar Mensenlinq, of afname van <a
              href={relativeRoute('standaard-rouwpagina')}>standaard</a> of <a
              href={relativeRoute('uitgebreide-rouwpagina')}>uitgebreide</a> rouwpagina</span>
          </div>
        </div>
      </section>


      <section>
        <div className="container cta">
          <div>
            <div>
              <h2 className={'mb-5'}>Gratis eenvoudige, digitale aanvulling</h2>
              <p>Ga jij als uitvaartondernemer mee met de digitalisering van jouw branche, en kun jij de vraag naar
                digitale producten van jouw klanten beantwoorden?</p>
              <p>Het online register van Mensenlinq is 4 producten in 1:
                <ol className={styles.orderedList}>
                  <li>De digitale rouwkaart</li>
                  <li>De digitale rouwadvertentie</li>
                  <li>Een digitaal condoleanceboek dat gebruikt kan worden tijdens de uitvaart</li>
                  <li>Een rouwpagina die steun en troost biedt tot ver na de uitvaart</li>
                </ol>
              </p>
            </div>
            <img src={imagePhoneFront} alt=""/>
          </div>
        </div>
      </section>

      <section className="bg-beige section-a !pb-10 ">
        <div className="container">
          <div className={'intro'}>
            <h2>Functionaliteiten van het online condoleanceregister</h2>
            <p>Bij <a href={relativeRoute('online-rouwpagina')}>doorplaatsing</a> van de rouwadvertentie naar
              Mensenlinq, of bij afname van een <a href={relativeRoute('standaard-rouwpagina')}>standaard</a> of <a
                href={relativeRoute('uitgebreide-rouwpagina')}>uitgebreide</a> rouwpagina, profiteren nabestaanden van
              alle functionaliteiten van het online condoleanceregister.</p>
          </div>
          <div className="tripple tripple-top">
            <div>
              <img src={imageFuncAanvulling} alt=""/>
              <h2>Digitale aanvulling op de rouwkaart</h2>
              <p>Voeg praktische informatie toe over de uitvaart en deel de pagina via verschillende online
                kanalen.<br/>
                Zo ontstaat een digitale rouwkaart.</p>
            </div>

            <div>
              <img src={imageFuncHerdenkingspagina} alt=""/>
              <h2>Digitaal condoleanceboek</h2>
              <p>Voeg de QR-code naar de pagina toe op de rouwkaart
                en/of toon de QR-code tijdens de uitvaart, zodat nabestaanden online condoleances kunnen ontvangen en op
                ieder moment kunnen teruglezen.</p>
            </div>

            <div>
              <img src={imageFuncCondoleance} alt=""/>
              <h2>Rouwpagina</h2>
              <p>Nabestaanden kunnen op elk gewenst moment reageren op de ontvangen condoleances, de pagina uitbreiden
                met het levensverhaal, foto’s en mooie herinneringen. Men komt op deze manier samen op één plek om de
                overleden dierbare te gedenken.</p>
            </div>


          </div>
        </div>
      </section>

      <section>
        <div className="container cta">
          <div className={'bg-beigedark'}>
            <div className={'p-10 text-center  '}>
              <h2 className={'mb-5'}>Wat kost het?</h2>
              <p>Met het <strong>gratis</strong> online condoleanceregister van Mensenlinq kun je nabestaanden een mooie
                extra service bieden, zonder dat het jou iets kost. <br />Jij betaalt <strong>geen implementatiekosten én geen
                  maandelijkse kosten</strong>.<br/>
                Nabestaanden kunnen gebruikmaken van het register wanneer zij hun printadvertentie doorplaatsen naar
                Mensenlinq (beschikbaar vanaf &euro;19,35 inclusief btw) of een <a
                  href={relativeRoute('standaard-rouwpagina')}>standaard</a> (beschikbaar vanaf &euro;19,35 inclusief
                btw) of <a
                  href={relativeRoute('uitgebreide-rouwpagina')}>uitgebreide</a> rouwpagina (vanaf maandag 2
                juni &euro;44,95 inclusief btw) afnemen. </p>
              <p>Alle <a href={relativeRoute('online-rouwpagina')}>doorgeplaatste rouwadvertenties</a> en rouwpagina's
                van uitvaarten die jij hebt begeleid, worden automatisch getoond in het online condoleanceregister op
                jouw eigen website. Hiermee is jouw portfolio zichtbaar, waardoor potentiële klanten in één oogopslag
                jouw ervaring, professionaliteit en betrokkenheid zien. Dit is een krachtige manier om het vertrouwen
                van nieuwe klanten te winnen en te laten zien hoe persoonlijk jouw aanpak is.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className={'section-a mb-10'}>
        <div className="container text-center">
          <div className={'intro'}>
            <h2>Hoe werkt het?</h2>
            <p>In drie eenvoudige stappen kun je jouw dienstenaanbod uitbreiden en de naamsbekendheid van jouw bedrijf
              vergroten door het online condoleanceregister van Mensenlinq op te nemen op de website.</p>
          </div>
          <div className={'lg:w-2/3 m-auto'}>
            <Tabs onChange={setCurrentTab} value={currentTab} light>
              <Tab>Stap 1</Tab>
              <Tab>Stap 2</Tab>
              <Tab>Stap 3</Tab>
            </Tabs>
            <div className={`flex bg-beige p-5 rounded-sm ${styles.tabs}`}>
              <TabPanel value={currentTab} index={0}>
                <div className={styles.image}>
                  <img src={imagePhoneContact} alt=""/>
                </div>
                <div className={styles.content}>
                  <h3>Vrijblijvende kennismaking inplannen</h3>
                  <p>Plan een vrijblijvend gesprek met ons door <a href={'https://forms.office.com/e/sE5fZgtB91'}>dit
                    formulier in te vullen</a> of een mail te sturen naar <a
                    href={'mailto:info@mensenlinq.nl'}>info@mensenlinq.nl</a>.
                    In het gesprek geven wij gedetailleerde informatie over het online
                    condoleanceregister, en geven we antwoord op jouw vragen.</p>
                </div>
              </TabPanel>
              <TabPanel value={currentTab} index={1}>
                <div className={styles.image}><img src={imagePhoneResult} alt=""/></div>
                <div className={styles.content}>
                  <h3>Implementatiegids online condoleanceregister</h3>
                  <p>Wil je gebruikmaken van het online condoleanceregister, sturen wij je de implementatiegids toe.
                    In de gids staat eenvoudig uitgelegd hoe jij het register in jouw huisstijl op de website kunt
                    integreren. De meeste webbouwers zijn gemiddeld 1 uur bezig met de implementatie van de code. </p>
                </div>
              </TabPanel>

              <TabPanel value={currentTab} index={2}>
                <div className={styles.image}><img src={imagePhoneDesign} alt=""/></div>
                <div className={styles.content}>
                  <h3>Het online condoleanceregister staat op jouw website!</h3>
                  <p>Vanaf het moment jij/de webbouwer de pagina zichtbaar maakt, ben je direct beter online vindbaar.
                    Daarnaast profiteer je gelijk van een completer online dienstenaanbod waarmee je voor de
                    nabestaanden extra service biedt van voor tot zelfs na de uitvaartdienst. </p>
                </div>
              </TabPanel>
            </div>
          </div>
        </div>
      </section>

      <Quote
        content={`Mensenlinq heeft bewezen een betrouwbare partner te zijn in het bieden van een online platform dat
          niet alleen helpt bij het delen van informatie, maar ook bij het bieden van comfort in tijden van verlies.
          Voor ons als uitvaartbegeleiding is het online condoleanceregister een mooie toevoeging en een
          waardevol hulpmiddel geworden in onze dienstverlening.`}
        author={'Uitvaartbegeleider'}/>

      <CTA_B2B/>

    </Page>
  );
}
